import { jsx as _jsx } from "react/jsx-runtime";
import { useIsMaxScreenSize } from 'marketplace-ui-common/hooks/useScreenSize';
import DesktopBrowseBar from './DesktopBrowseBar';
import MobileBrowseBar from './MobileBrowseBar';
export default function BrowseBar({
  hasActiveOfferingType = true,
  previewCollectionId
}) {
  const isMobile = useIsMaxScreenSize('sm');
  return isMobile ? /*#__PURE__*/_jsx(MobileBrowseBar, {}) : /*#__PURE__*/_jsx(DesktopBrowseBar, {
    hasActiveOfferingType: hasActiveOfferingType,
    previewCollectionId: previewCollectionId
  });
}